import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      invoice: {
         invoiceCreate: {
            modal: {
               apiTokenFault: 'Problem z połączeniem z Fakturownią. Skontaktuj się ze Wsparciem Technicznym.',
               close: 'Zamknij',
               companyDetails: 'Dane nabywcy',
               confirmButtonLabel: 'Wystaw fakturę',
               downloadDataFromCentralStatisticalOffice: 'Pobierz dane z GUS',
               downloadDataFromCentralStatisticalOfficeError: 'Nie udało się pobrać danych z GUS.',
               externalSystemBusinessFault:
                  'Nie udało się utworzyć faktury. Komunikat z systemu Fakturownia: {{messageFromFakturownia}}',
               forCompany: 'Firmę',
               forPrivateIndividual: 'Osobę prywatną',
               invoiceCreateSuccess: 'Wystawiono fakturę.',
               invoiceFor: 'Faktura na',
               payment: 'Kwota opłacona',
               paymentMethod: 'Metoda płatności',
               paymentMethodDescription: '{{method}} ({{description}})',
               paymentMethodMap: {
                  CARD: 'Karta płatnicza',
                  CASH: 'Gotówka',
                  OTHER: 'Inna',
                  TRANSFER: 'Przelew',
               },
               privateIndividualDetails: 'Dane pacjenta',
               servicesDetails: 'Dane usług',
               table: {
                  addService: 'Dodaj usługę',
                  medicalServiceNameTooltip: 'NAZWA USŁUGI ROZLICZENIOWEJ',
                  name: {
                     label: 'Nazwa usługi na fakturze',
                     placeholder: 'Uzupełnij nazwę usługi...',
                  },
                  ordinalNumber: 'Lp.',
                  quantity: 'Ilość',
                  taxRate: 'VAT',
                  taxRateMap: {
                     /* eslint-disable sort-keys-fix/sort-keys-fix */
                     VAT_0: '0%',
                     VAT_8: '8%',
                     VAT_23: '23%',
                     NO_VAT: 'ZW',
                     /* eslint-enable */
                  },
                  unit: 'Jednostka',
                  unitMap: {
                     ITEM: 'szt.',
                     SERVICE: 'usługa',
                  },
                  unitPrice: 'Cena brutto',
                  unitPriceTooltip: 'Cena różni się od ceny wskazanej podczas wizyty',
               },
               title: 'Wystaw fakturę',
               titleWithReceipt: 'Wystaw fakturę do paragonu',
               unitPriceSum: 'RAZEM BRUTTO <bold>{{grossPrice}}</bold>',
               unitPriceSumPlaceholder: 'RAZEM BRUTTO <bold>- zł</bold>',
               visitDate: 'Data wizyty',
               withReceipt: {
                  continueWithoutReceipt: 'Kontynuuj bez paragonu',
                  printReceipt: 'Drukuj paragon',
                  subtitle: 'Czy chcesz dodatkowo wydrukować paragon fiskalny?',
                  title: 'Wystawiasz fakturę na osobę prywatną',
               },
            },
         },
         invoiceDownloadError: 'Nie udało się pobrać faktury.',
         issuedInvoices: {
            downloadFault: 'Nie udało się pobrać listy faktur.',
            tabName: 'Faktury',
            table: {
               buyer: 'Nabywca',
               emptyStatePlaceholder: {
                  heading: 'Brak faktur do wyświetlenia',
                  subheading: 'Nie posiadasz wystawionych faktur.',
               },
               grossPrice: 'Wartość brutto',
               invoiceNumber: 'Numer',
               invoiceType: 'Rodzaj',
               issuedDate: 'Data wystawienia',
               price: '{{grossPrice}} PLN',
               type: {
                  CORRECTION: 'Korekta',
                  VAT: 'Faktura VAT',
               },
            },
         },
         panel: {
            bannerTitle:
               'Włącz integrację z Fakturownią i zacznij wystawiać faktury dla pacjentów przez eGabinet już dziś!',
            createAccount: 'Załóż konto',
            fiscalPrintIntegration: {
               header: 'Integracja z drukarkami fiskalnymi',
               moduleConfigurationRequired:
                  'Do poprawnego działania integracji wymagane jest posiadanie i skonfigurowanie modułu Fiskator w Fakturowni.',
               privateMedicalServiceConfigurationRequired:
                  'Do poprawnego działania integracji wymagane jest skonfigurownie i korzystanie z minimum jednej usługi rozliczeniowej w module usług prywatnych.',
               saveError: 'Nie udało się zapisać konfiguracji. Spróbuj ponownie później.',
               saveSuccessDisabled: 'Integracja z drukarką fiskalną została wyłączona.',
               saveSuccessEnabled: 'Integracja z drukarką fiskalną została włączona.',
               toggleLabel: 'Włączenie integracji z drukarką fiskalną',
            },
            integrationEnabled: 'Integracja z Fakturownią została włączona.',
            invoiceCurrentOffer: 'Zobacz aktualną ofertę',
            invoiceOffer: 'Poznaj ofertę',
            invoiceProviderAccountInfo: 'Dane konta w Fakturowni',
            login: 'Zaloguj',
            modal: {
               companyDetails: 'Dane firmy',
               confirmAndCreateAccount: 'Potwierdź dane i załóż konto',
               confirmLeavingForm: 'Czy na pewno chcesz anulować? Konto w Fakturowni nie zostanie założone.',
               creatingAccount: 'Oczekiwanie na odpowiedź z Fakturowni',
               creatingAccountFailed: 'Nie udało się założyć konta.',
               invoiceLoginDetails: 'Dane logowania do Fakturowni',
               privacyPolicyAndGdpr: 'Polityką prywatności i RODO',
               privacyPolicyAndGdprLabel: 'Oświadczam, że zapoznałem się z <link /> Fakturownia.',
               terms: 'Regulaminem',
               termsLabel: 'Oświadczam, że zapoznałem się z <link /> korzystania z Fakturownia.',
               title: 'Załóż konto w Fakturowni',
            },
            yourLogin: '<bold>Twój login:</bold> {{login}}',
            yourUrl: '<bold>Twój url:</bold> {{url}}',
         },
         shared: {
            components: {
               bankName: {
                  label: 'Bank',
                  placeholder: 'Wpisz nazwę banku...',
               },
               bdoNumber: {
                  invalid: 'Nieprawidłowy numer BDO',
                  label: 'Numer BDO',
                  minLength: 'Wymagane podanie 9 znaków',
                  placeholder: 'Wpisz numer BDO...',
               },
               companyName: 'Nazwa firmy',
               description: {
                  label: 'Uwagi do faktury',
                  placeholder: 'Uzupełnij uwagi do faktury...',
               },
               password: {
                  invalid:
                     'Hasło musi składać się z co najmniej 8 znaków, zawierać małe i wielkie litery oraz cyfry lub znaki specjalne',
               },
               paymentDate: 'Data zapłaty',
               taxExemptionBasis: {
                  label: 'Podstawa zwolnienia z podatku',
                  map: {
                     EXEMPTION_18:
                        'Zwolnienie z VAT na podstawie art. 43 ust. 1 pkt 18 Ustawy o podatku od towarów i usług z dnia 11 marca 2004 z późn. zm.',
                     EXEMPTION_18A:
                        'Zwolnienie z VAT na podstawie art. 43 ust. 1 pkt 18a Ustawy o podatku od towarów i usług z dnia 11 marca 2004 z późn. zm.',
                     EXEMPTION_19:
                        'Zwolnienie z VAT na podstawie art. 43 ust. 1 pkt 19 Ustawy o podatku od towarów i usług z dnia 11 marca 2004 z późn. zm.',
                     EXEMPTION_19A:
                        'Zwolnienie z VAT na podstawie art. 43 ust. 1 pkt 19a Ustawy o podatku od towarów i usług z dnia 11 marca 2004 z późn. zm.',
                     EXEMPTION_20:
                        'Zwolnienie z VAT na podstawie art. 43 ust. 1 pkt 20 Ustawy o podatku od towarów i usług z dnia 11 marca 2004 z późn. zm.',
                     NO_EXEMPTION: 'Nie dotyczy',
                  },
               },
               taxIdentifier: {
                  invalid: 'Nieprawidłowy NIP',
                  minLength: 'Wymagane podanie 10 znaków',
               },
            },
            fetchError: 'Nie udało się pobrać danych. Spróbuj ponownie później.',
         },
         tabName: 'Faktury',
      },
   },
};

export const invoiceTranslationKeys = createScopedTranslationKeys(translations.pl, 'invoice');
export const invoicePanelTranslationKeys = invoiceTranslationKeys.panel;
export const invoiceCreateAccountModalTranslationKeys = invoiceTranslationKeys.panel.modal;
export const invoiceCreateTranslationKeys = invoiceTranslationKeys.invoiceCreate;
export const invoiceCreateModalTranslationKeys = invoiceTranslationKeys.invoiceCreate.modal;
export const invoiceSharedTranslationKeys = invoiceTranslationKeys.shared;
export const invoiceSharedComponentsTranslationKeys = invoiceTranslationKeys.shared.components;
export const issuedInvoicesTranslationKeys = invoiceTranslationKeys.issuedInvoices;
